import React from "react";
import CustomCheckbox from "../../Components/CustomCheckBox";
import {withButtonLoader} from "../../helpers";

const CreditCardSwipeEntryConverge = ({
    paymentType,
    handleInputChange,
    handlePay,
    firstName,
    lastName,
    lastFourNumbers,
    disguisedSwipeNumber,
    isPaymentSaveDetails,
    setIsPaymentSaveDetails,
    isDefault,
    setIsDefault,
    transactionLoading
}) => {
    return (
        <div
            className={`tab-pane fade ${paymentType === "swipe" ? "show active" : ""}`}
            id="pills-contact"
            role="tabpanel"
            aria-labelledby="pills-contact-tab"
        >
            <div className="sos-content payment-inner-toggleable">
                <form onSubmit={(e) => handlePay(e)}>
                    <div className="form-group mb-3">
                        <label
                            htmlFor="exampleInputName4"
                            className="form-label payment-form-label"
                        >
                            Cardholder Name
                        </label>
                        <div className="row g-2">
                            <div className="col-md">
                                <div className="payment-controlpanl-style">
                                    <input
                                        type="text"
                                        name="cardFirstName"
                                        className="form-control custom-input-border-css"
                                        id="exampleInputName3"
                                        aria-describedby="nameHelp"
                                        placeholder="First Name"
                                        onChange={(e) => handleInputChange(e)}
                                        value={firstName || ""}
                                    />
                                </div>
                            </div>
                            <div className="col-md">
                                <div>
                                    <input
                                        type="text"
                                        name="cardLastName"
                                        className="form-control custom-input-border-css"
                                        id="exampleInputName3"
                                        aria-describedby="nameHelp"
                                        placeholder="Last Name"
                                        onChange={(e) => handleInputChange(e)}
                                        value={lastName || ""}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group mb-3">
                        <label
                            htmlFor="exampleInputPassword1"
                            className="form-label payment-form-label"
                        >
                            Card Number
                        </label>
                        <input
                            type="tel"
                            name="cardnumber"
                            className="form-control custom-input-border-css"
                            placeholder="Enter Credit Card Number"
                            required
                            onChange={(e) => handleInputChange(e)}
                            value={lastFourNumbers ? disguisedSwipeNumber : ""}
                        />
                    </div>
                    <div className="row g-2">
                        {/* <div className="col-md">
                            <div className="payment-controlpanl-style">
                              <div>
                                <label className="payment-form-label">
                                  Expiry Date
                                </label>
                              </div>
                              <input
                                type="tel"
                                className="form-control custom-input-border-css"
                                id="expiry"
                                placeholder="mm/yy"
                                name="expiry"
                                pattern="\d\d/\d\d"
                                required
                                onChange={(e) => handleInputChange(e)}
                              />
                            </div>
                          </div> */}
                        {/* <div className="col-md">
                            <div >
                              <div>
                                <label className="payment-form-label">
                                  Security Code
                                </label>
                              </div>
                              <input
                                type="tel"
                                className="form-control custom-input-border-css"
                                placeholder="Enter CVC"
                                name="cvc"
                                pattern="\d{3,4}"
                                required
                                onChange={(e) => handleInputChange(e)}
                              />
                            </div>
                          </div> */}
                    </div>
                    <div className="checkbox-list mt-3">
                        <label
                            className="label-check font-weight-light float-end">
                            <CustomCheckbox
                                name="isPaymentSaveDetails"
                                checked={isPaymentSaveDetails}
                                onChange={(e) => setIsPaymentSaveDetails(!isPaymentSaveDetails)}
                            />
                            Save these payment details for future payments
                        </label>
                        <div className="payment-checbox">
                            <label
                                className="font-weight-light label-check ml-xl-5">
                                <CustomCheckbox
                                    name="isDefault"
                                    checked={isDefault}
                                    onChange={(e) => setIsDefault(!isDefault)}
                                />
                                Set as default payment method
                            </label>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button
                            type="submit"
                            className="sos-mack-btn sos-custom-btn-css"
                            disabled={transactionLoading}
                        >
                            {withButtonLoader("Make a Payment", transactionLoading)}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreditCardSwipeEntryConverge;
